import {makePartialFrameElements} from '../util/makePartialHostElement';
import {FrameElements} from './FrameElements.interface';

export function makeFrameElements(): FrameElements {
  const PartialFrameElements = makePartialFrameElements();

  const documentFragment = new DocumentFragment();
  documentFragment.appendChild(PartialFrameElements.shadowHostElement);

  return {
    documentFragment,
    ...PartialFrameElements,
  };
}
